import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Breadcrumb, BreadcrumbItem, Col } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import { FormattedMessage, injectIntl } from "react-intl";
import ObjectUtils from "../../../utils/ObjectUtils";
import StandardView from "../../common/StandardView";
import ActionFieldTable from "./ActionFieldTable";
import CreateEditActionFieldDialog from "./CreateEditActionFieldDialog";
import CreateEditIndicatorDialog from "./CreateEditIndicatorDialog";
import CreateEditResultDialog from "./CreateEditResultDialog";
import IndicatorsTable from "./IndicatorsTable";
import ResultsTable from "./ResultsTable";

class IndicatorManagement extends Component {
  componentDidMount() {
    this.props.clearMessages();
    this.props.loadActionFields();
    this.props.loadLibraryQuestions();
  }

  componentWillUnmount() {
    this.props.clearMessages();
    this.props.resetState();
  }

  render() {
    const {
      actionFields,
      results,
      indicators,
      questions,
      libraryQuestions,

      selectedActionField,
      selectedResult,

      editedActionField,
      editedResult,
      editedIndicator,

      editActionField,
      editResult,
      editIndicator,

      createActionField,
      createResult,
      createIndicator,

      saveActionField,
      saveResult,
      saveIndicator,

      indicatorCodeValid,

      locale
    } = this.props;

    let viewActions = [
      {
        labelKey: "indicator.management.new.action.field",
        onClick: () => createActionField(),
        icon: <FontAwesomeIcon icon={faPlus} className="me-2" />
      }
    ];
    let level = "actionfields";
    if (selectedActionField) {
      level = "results";
      viewActions = [
        {
          labelKey: "indicator.management.new.active.element",
          onClick: () => createResult(),
          icon: <FontAwesomeIcon icon={faPlus} className="me-2" />
        }
      ];
    }
    if (selectedResult) {
      level = "indicators";
      viewActions = [
        {
          labelKey: "indicator.management.new.indicator",
          onClick: () => createIndicator(),
          icon: <FontAwesomeIcon icon={faPlus} className="me-2" />
        }
      ];
    }

    return (
      <StandardView id="indicatorManagement" titleKey="indicator.management.page.title" actions={viewActions}>
        <Row>
          <Col>
            <Breadcrumb>
              <BreadcrumbItem onClick={() => this.props.selectedActionFieldChange(undefined)}>
                <FormattedMessage id="indicator.management.page.title" />
              </BreadcrumbItem>
              {selectedActionField && (
                <BreadcrumbItem
                  onClick={() => this.props.selectedResultChange(undefined)}
                  title={selectedActionField.name[locale]}
                >
                  {selectedActionField.name[locale]}
                </BreadcrumbItem>
              )}
              {selectedResult && (
                <BreadcrumbItem
                  onClick={() => this.props.selectedResultChange(undefined)}
                  title={selectedResult.name[locale]}
                >
                  {ObjectUtils.trunc(selectedResult.name[locale], 70)}
                </BreadcrumbItem>
              )}
            </Breadcrumb>
          </Col>
        </Row>
        <Row>
          <Col>
            {level === "actionfields" && (
              <ActionFieldTable
                actionFields={actionFields}
                locale={locale}
                onClick={this.props.selectedActionFieldChange}
                onEdit={this.props.editActionField}
                onDelete={this.props.deleteActionField}
              />
            )}
            {level === "results" && (
              <ResultsTable
                results={results}
                locale={locale}
                onClick={this.props.selectedResultChange}
                onEdit={this.props.editResult}
                onDelete={this.props.deleteResult}
              />
            )}
            {level === "indicators" && (
              <IndicatorsTable
                indicators={indicators}
                questions={questions}
                locale={locale}
                onClick={this.props.selectedResultChange}
                onEdit={this.props.editIndicator}
                onDelete={this.props.deleteIndicator}
              />
            )}

            {editedActionField && (
              <CreateEditActionFieldDialog
                actionField={editedActionField}
                onCancel={() => editActionField(undefined)}
                onSave={() => saveActionField()}
                onChange={(actionField) => editActionField(actionField)}
                locale={locale}
                show
              />
            )}
            {editedResult && (
              <CreateEditResultDialog
                result={editedResult}
                actionFields={actionFields}
                onCancel={() => editResult(undefined)}
                onSave={() => saveResult()}
                onChange={(result) => editResult(result)}
                locale={locale}
                show
              />
            )}
            {editedIndicator && (
              <CreateEditIndicatorDialog
                indicator={editedIndicator}
                questions={questions}
                libraryQuestions={libraryQuestions}
                onCancel={() => editIndicator(undefined)}
                onSave={() => saveIndicator()}
                onChange={(indicator) => editIndicator(indicator)}
                indicatorCodeValid={indicatorCodeValid}
                locale={locale}
                show
              />
            )}
          </Col>
        </Row>
      </StandardView>
    );
  }
}

IndicatorManagement.propTypes = {
  actionFields: PropTypes.arrayOf(PropTypes.object),
  results: PropTypes.arrayOf(PropTypes.object),
  indicators: PropTypes.arrayOf(PropTypes.object),
  questions: PropTypes.arrayOf(PropTypes.object),
  libraryQuestions: PropTypes.arrayOf(PropTypes.object),

  locale: PropTypes.string.isRequired,

  indicatorCodeValid: PropTypes.bool,

  selectedActionFieldChange: PropTypes.func.isRequired,
  selectedResultChange: PropTypes.func.isRequired,

  loadActionFields: PropTypes.func.isRequired,
  loadLibraryQuestions: PropTypes.func.isRequired,

  saveActionField: PropTypes.func.isRequired,
  saveResult: PropTypes.func.isRequired,
  saveIndicator: PropTypes.func.isRequired,

  editActionField: PropTypes.func.isRequired,
  editResult: PropTypes.func.isRequired,
  editIndicator: PropTypes.func.isRequired,

  createActionField: PropTypes.func.isRequired,
  createResult: PropTypes.func.isRequired,
  createIndicator: PropTypes.func.isRequired,

  editedActionField: PropTypes.object,
  editedResult: PropTypes.object,
  editedIndicator: PropTypes.object,

  deleteActionField: PropTypes.func.isRequired,
  deleteResult: PropTypes.func.isRequired,
  deleteIndicator: PropTypes.func.isRequired,

  selectedActionField: PropTypes.object,
  selectedResult: PropTypes.object,

  clearMessages: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired,

  intl: PropTypes.object
};

export default injectIntl(IndicatorManagement);
